export const NAV_LINKS = [
  { id: "about", label: "about" },
  { id: "services", label: "services" },
  { id: "gallery", label: "gallery" },
  { id: "contact", label: "contact" },
];

export const SERVICES = [
  {
    key: "production",
    title: "production",
    alt: "Behind-the-scenes at a full production shoot at Peanut Factory Studio — photographer with camera capturing a model on a red backdrop with softboxes and lighting stands",
    blurb:
      "full end-to-end production — we take your moodboard from brief to final deliverables, sourcing the whole crew and running the shoot start to finish.",
    tag: "01",
    image:
      "https://customer-assets.emergentagent.com/job_one-page-modern/artifacts/n94m4by1_unnamed%20%283%29.jpg",
    accent: "#FFEB85",
  },
  {
    key: "studio-hire",
    title: "studio hire",
    alt: "Daylight photography studio hire space with pink stairs, plants and skylights at Peanut Factory, Hackney Wick",
    blurb:
      "natural daylight studio with pink stairs, plants and skylights — set up ready for stills + motion.",
    tag: "02",
    image:
      "https://customer-assets.emergentagent.com/job_one-page-modern/artifacts/9103ab2r_PEANUT%20FACTORY%20STUDIO-10.jpg",
    accent: "#FFC4D9",
  },
  {
    key: "photography",
    title: "photography & video",
    alt: "Behind-the-scenes at Peanut Factory Studio — photographer with Profoto softbox lighting a set for a photography shoot",
    blurb:
      "in-house photography, videography and production for editorial, fashion, e-com and brand campaigns.",
    tag: "03",
    image:
      "https://customer-assets.emergentagent.com/job_one-page-modern/artifacts/tpwmpb8c_unnamed%20%285%29.jpg",
    accent: "#FFEB85",
  },
  {
    key: "equipment",
    title: "equipment",
    alt: "Lighting kits, c-stands, modifiers and grip equipment available at the daylight studio",
    blurb:
      "lighting kits, c-stands, modifiers and grip — add a free lighting kit with every full day booking.",
    tag: "04",
    image:
      "https://customer-assets.emergentagent.com/job_one-page-modern/artifacts/gcdrlcpq_PHOTO-2026-03-05-12-14-43%20%283%29.jpg",
    accent: "#FDE68A",
  },
  {
    key: "retouching",
    title: "retouching",
    alt: "High-end colour grading and retouching post production at Peanut Factory Studio",
    blurb:
      "high-end colour, clean-up and finishing — delivered in the look your campaign needs.",
    tag: "05",
    image:
      "https://customer-assets.emergentagent.com/job_one-page-modern/artifacts/yz9mpy04_unnamed%20%284%29.jpg",
    accent: "#FFC4D9",
  },
  {
    key: "head-shots",
    title: "head shots",
    alt: "Affordable headshot photography session in the daylight studio, Hackney Wick London",
    blurb:
      "affordable headshot packages starting from one hour sessions and 5 final images.",
    tag: "06",
    image:
      "https://customer-assets.emergentagent.com/job_one-page-modern/artifacts/u0molbw5_260401_FIFI_005web.jpg",
    accent: "#FFEB85",
  },
  {
    key: "props",
    title: "props + furniture",
    alt: "Blue corduroy cantilever chair with chrome frame — available on-site at Peanut Factory Studio, Hackney Wick",
    blurb:
      "folding chairs, tables, plants and a curated prop library available on-site.",
    tag: "07",
    image:
      "https://customer-assets.emergentagent.com/job_one-page-modern/artifacts/tgah3tkb_PROPS%2BFURNITURE025.jpg",
    accent: "#FFEB85",
  },
];

export const GALLERY = [
  {
    src: "https://static.wixstatic.com/media/c49bcf_caaba6384540496db3dcc4b1909c87fe~mv2.jpg/v1/fill/w_900,h_1200,al_c,q_85,enc_avif,quality_auto/gallery-1.jpg",
    alt: "Yellow colorama backdrop and natural daylight in the studio — Peanut Factory, Hackney Wick",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_one-page-modern/artifacts/6jrg9ag8_FullSizeRender3_edited.jpg",
    alt: "Editorial fashion shoot in the daylight photography studio, East London",
  },
  {
    src: "https://static.wixstatic.com/media/c49bcf_65c50731580e4b2794ff20e456889175~mv2.jpg/v1/fill/w_900,h_1200,al_c,q_85,enc_avif,quality_auto/gallery-2.jpg",
    alt: "Pink stairs and white walls inside the Victorian peanut factory studio, Hackney Wick",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_one-page-modern/artifacts/4084ua6v_Studio001.jpg",
    alt: "600 sqft daylight studio interior with skylights — Peanut Factory Studio, Fish Island",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_one-page-modern/artifacts/3rdv3tjn_Studio2026_-014.jpg",
    alt: "Set styling and lighting setup inside the daylight photography studio, London E3",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_one-page-modern/artifacts/ki1lt78j_Studio2026_-022.jpg",
    alt: "Sawtooth roof skylights flooding the studio with diffused daylight, Hackney Wick",
  },
  {
    src: "https://static.wixstatic.com/media/c49bcf_fb20a3df718c47b5866d2c243e44a141~mv2.jpg/v1/fill/w_900,h_1200,al_c,q_85,enc_avif,quality_auto/c49bcf_fb20a3df718c47b5866d2c243e44a141~mv2.jpg",
    alt: "Studio interior with plants, vintage furniture and natural light — Peanut Factory, East London",
  },
  {
    src: "https://static.wixstatic.com/media/c49bcf_04ad8a352dcd4fada99f47eec293c04c~mv2.jpg/v1/fill/w_900,h_1200,al_c,q_85,enc_avif,quality_auto/c49bcf_04ad8a352dcd4fada99f47eec293c04c~mv2.jpg",
    alt: "Behind-the-scenes shoot at the daylight photographic studio, Hackney Wick London",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_one-page-modern/artifacts/wh56nn8o_Studio007.jpg",
    alt: "Wide-angle view of the 600 sqft daylight studio — Peanut Factory, Fish Island, London E3",
  },
];

export const PROCESS_STEPS = [
  {
    n: "01",
    title: "enquire",
    body: "send us your dates, services and a quick brief — we get back same day.",
  },
  {
    n: "02",
    title: "plan",
    body: "we tailor lighting, props and crew to fit your shoot.",
  },
  {
    n: "03",
    title: "shoot",
    body: "show up to a studio set up and ready — we look after the rest.",
  },
  {
    n: "04",
    title: "deliver",
    body: "edit, colour and retouch — delivered in the look your campaign needs.",
  },
];

export const SERVICE_OPTIONS = [
  "Production",
  "Studio Hire",
  "Photography / Video Services",
  "Retouching",
  "Head Shots",
];
